import styled from 'styled-components'

export const Feedback = styled.div`
  background: ${({ theme }) => theme.colors.neutralW20};
  border: 1px solid ${({ theme }) => theme.colors.neutralW30};
  border-radius: 5px;
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  flex-shrink: 0;
  gap: 12px;
  margin-bottom: 16px;
  min-width: 0;
  padding: 12px 16px;
  width: 100%;
`

export const Message = styled.p`
  color: ${({ $isError, theme }) =>
    $isError ? theme.colors.error70 : theme.colors.neutralW90};
  font-family: ${({ theme }) => theme.fonts?.primary || 'Nunito Sans'};
  font-size: 14px;
  line-height: 20px;
  margin: 0;
  overflow-wrap: anywhere;
`

export const Actions = styled.div`
  align-items: center;
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
  min-width: 0;
`
